/**
 * Create Add-On Product API
 * Feature: 023-flexible-training-product
 */

import axiosInstance from '../axiosInstance';
import { AddOnProduct, CreateAddOnProductRequest } from './types';

export const createAddOnProduct = async (data: CreateAddOnProductRequest): Promise<AddOnProduct> => {
  const response = await axiosInstance.post<AddOnProduct>('/api/add-on-products', data);
  return response.data;
};
